export var LOG_PREFIX = 'storage:redis: ';
export var DEFAULT_CACHE_SIZE = 30000;
export var REFRESH_RATE = 300000; // 300000 ms = start after 5 mins
export var TTL_REFRESH = 3600; // 1hr
